import {Action} from "../../../action/action";
import type {BasisTypeState} from "../basistypestate";

export const NEXT_STATE = "NEXT_STATE";
export class Next extends Action<typeof NEXT_STATE, undefined> {
  readonly type = NEXT_STATE;
  protected state: BasisTypeState;

  constructor(state: BasisTypeState) {
    super(state);
    this.state = state;
  }

  /**
   * CustomerType and BasisType has to be chosen before this action becomes available
   * @returns
   */
  public isDoable(): boolean {
    const {customerType, basisType} = this.state.getData();
    const hasBasisType = this.hasValue(basisType);
    const hasCustomerType = this.hasValue(customerType);
    return hasBasisType && hasCustomerType && basisType.canBeBookedBy(customerType);
  }

  public isValid(): boolean {
    return this.isDoable();
  }
}
